// extracted by mini-css-extract-plugin
module.exports = {"senceForm":"Sence_senceForm__3FDsv","hidden":"Sence_hidden__2MPVq"};